import { useIntParam, useNavigationContext } from 'hooks';
import { lrwSessionStore } from 'store';

export const useLrwSessionDetails = () => {
  const lrwSessionId = useIntParam('sessionId');
  const { locationId } = useNavigationContext();

  const {
    data: lrwSession,
    isLoading,
    isError,
    error,
  } = lrwSessionStore.service.lrwSessionApi.useGetLrwSessionDetailsQuery({
    lrwSessionId,
    locationId,
  });

  const isNotFound = isError && 'status' in error && error.status === 404;

  return { lrwSession, isLoading, isNotFound };
};
